import { type Conflict, type ReorderConflict } from '@editor2/types/conflict';
import { type CourseState } from '@editor2/types/courseState';
import { getReorderConflictIndex } from '@editor2/services/conflictResolutionService';
import { ChangesStatus } from '@editor2/types/changesStatus';
import { getChapterByPageGroupId } from '@editor2/components/CourseChangesDiff/helpers';
import { filterByEntityId } from '../common/conflictResolutionHelper';

export class PageGroupModifiedDeletedConflictResolver {
	acceptCurrent = (state: CourseState, conflict: Conflict | ReorderConflict) => {
		const { entityId } = conflict;
		const initialParent = getChapterByPageGroupId(state.initialCourse.chapters, entityId);

		const filteredInitial = filterByEntityId(initialParent.page_groups, entityId);
		const parentId = initialParent.family_id;

		state.initialCourse.chapters.entities[parentId].page_groups = filteredInitial;
		state.changes.page_groups.entities[entityId] = [ChangesStatus.New];

		// update page group reorder conflict if exists
		const reorderConflictIndex = getReorderConflictIndex(state, parentId);
		if (reorderConflictIndex > -1) {
			state.conflicts[reorderConflictIndex].initial = filteredInitial;
		}
	};

	acceptIncoming = (state: CourseState, conflict: Conflict | ReorderConflict) => {
		const { entityId } = conflict;
		const initialParent = getChapterByPageGroupId(state.initialCourse.chapters, entityId);
		const currentParent = state.chapters.entities[initialParent.family_id];

		const filteredInitial = filterByEntityId(initialParent.page_groups, entityId);
		const filteredCurrent = filterByEntityId(currentParent.page_groups, entityId);

		const parentId = initialParent.family_id;

		state.initialCourse.chapters.entities[parentId].page_groups = filteredInitial;
		state.chapters.entities[parentId].page_groups = filteredCurrent;
		state.changes.page_groups[conflict.entityId] = [];

		// update page group reorder conflict if exists
		const reorderConflictIndex = getReorderConflictIndex(state, parentId);
		if (reorderConflictIndex > -1) {
			state.conflicts[reorderConflictIndex].initial = filteredInitial;
			state.conflicts[reorderConflictIndex].current = filteredCurrent;
		}
	};

	acceptBoth = (state: CourseState, conflict: Conflict | ReorderConflict) => {
		throw new Error('Accept both is not allowed for this type of conflict');
	};
}
